import $ from 'jquery';

$('.menu-display').on('click', function () {
  $('.nav-main').addClass('active');
  $('.translucent-layer').addClass('active');
});
$('.translucent-layer').on('click', function () {
  anMenu();
});
$('.nav-close').on('click', function () {
  anMenu();
});

function anMenu() {
  $('.translucent-layer').removeClass('active');
  $('.nav-main').removeClass('active');
}
$('.nav-main ul > li.child-menu a i').on('click', function (e) {
  e.preventDefault();
  var id = $(this).data('id');
  if (id) {
    var ul = $('.nav-main ul > li[data-id="' + id + '"] > ul.child-menu-ul');
    if (ul.hasClass('active')) {
      $(
        '.nav-main ul > li[data-id="' + id + '"] > ul.child-menu-ul',
      ).removeClass('active');
      $('.nav-main ul > li[data-id="' + id + '"].child-menu').removeClass(
        'active',
      );
    } else {
      $('.nav-main ul > li[data-id="' + id + '"] > ul.child-menu-ul').addClass(
        'active',
      );
      $('.nav-main ul > li[data-id="' + id + '"].child-menu').addClass(
        'active',
      );
    }
  }
});
